class YouTubeReviewVideo extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-youtube-play]');
    this.button?.addEventListener('click', () => this.loadVideo(), { once: true });
  }

  loadVideo() {
    const videoId = this.dataset.videoId;
    if (!videoId) return;

    const iframe = document.createElement('iframe');
    iframe.className = 'youtube-review-grid__iframe';
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
    iframe.title = this.dataset.videoTitle || 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    this.replaceChildren(iframe);
  }
}

if (!customElements.get('youtube-review-video')) {
  customElements.define('youtube-review-video', YouTubeReviewVideo);
}
